import React from 'react';
import styled from 'styled-components';
import ICellProps from '../ICellProps';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ColorPicker, TooltipHost } from 'office-ui-fabric-react';
import moment from 'moment';
import Readonly from '../Readonly';
import {
  Modal,
  PrimaryButton,
  Stack,
  DefaultButton,
} from 'office-ui-fabric-react';
import { string } from 'prop-types';

interface IProps extends ICellProps {
  onChange: (value: string) => void;
  labelAsText?: boolean;
}

interface IState {
  isMapShowing: boolean;
}

const DataBlock = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  font-size: 12px;
  align-items: center;
  padding: 0 10px;
  cursor: pointer;
  color: #003a72;
`;

const TextInput = styled.input`
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  margin: 0;
  height: 100%;
  width: 100%;
  border: none;
  padding: 0;
  box-sizing: border-box;
  padding: 0 10px;
  outline: none;
`;

class ColorCtrl extends React.Component<IProps> {
  state = {
    isMapShowing: false,
  };
  currentColor: string = '#000000';

  onShowEditDlg = (): void => {
    this.currentColor = this.props.value;
    this.setState({ isMapShowing: true });
  };

  onCloseEditDlg = (): void => {
    this.setState({ isMapShowing: false });
  };

  onAccept = (): void => {
    if (this.props.onChange) {
      this.props.onChange(this.currentColor);
    }
    this.setState({ isMapShowing: false });
  };

  render() {
    const { value, readonly, labelAsText } = this.props;
    return (
      <DataBlock onClick={!readonly ? this.onShowEditDlg : undefined}>
        <TooltipHost
          content="Недостаточно прав доступа"
          id={'changeColor'}
          calloutProps={{ gapSpace: 0 }}
          hidden={!readonly}
        >
          {
            labelAsText ?
              <div>
                {value}
                <Icon iconName={'Edit'} onClick={!readonly ? this.onShowEditDlg : undefined} style={{marginLeft: 3}} />
              </div> :
              <div style={{width: 20, height: 20, backgroundColor: value || '#000000'}}/>
          }
        </TooltipHost>
        {this.state.isMapShowing && (
          <Modal isOpen={true}>
            <Stack horizontal>
              <ColorPicker
                color={this.currentColor || '#000000'}
                alphaSliderHidden={true}
                blueLabel={'Синий'}
                redLabel={'Красный'}
                greenLabel={'Зеленый'}
                onChange={(ev, clr) => {
                  this.currentColor = clr.str;
                }}
              />
            </Stack>
            <Stack
              horizontal
              horizontalAlign={'end'}
              tokens={{ childrenGap: 10 }}
              styles={{ root: { padding: '10px;' } }}
            >
              <PrimaryButton text="Применить" onClick={() => this.onAccept()} />
              <DefaultButton
                text="Отмена"
                onClick={() => this.onCloseEditDlg()}
              />
            </Stack>
          </Modal>
        )}
      </DataBlock>
    );
  }
}

export default ColorCtrl;
